// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-common-attributes-makeAttrLabel-labelMakers-dict-DictRef-DictRef-module__box--No_Ts .ant-tag {
  margin: 0;
}
.src-common-attributes-makeAttrLabel-labelMakers-dict-DictRef-DictRef-module__multiple--rVpj_ {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/dict/DictRef/DictRef.module.less"],"names":[],"mappings":"AAAA;EAEI,SAAA;AAAJ;AAIA;EACE,WAAA;AAFF","sourcesContent":[".box {\n  :global(.ant-tag) {\n    margin: 0;\n  }\n}\n\n.multiple {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-common-attributes-makeAttrLabel-labelMakers-dict-DictRef-DictRef-module__box--No_Ts`,
	"multiple": `src-common-attributes-makeAttrLabel-labelMakers-dict-DictRef-DictRef-module__multiple--rVpj_`
};
export default ___CSS_LOADER_EXPORT___;
